export default __webpack_public_path__ + "static/media/AvenirNext-UltraLightItalic.9738db2b.woff";